import React from "react";
import { ShieldCheck, FlaskConical, Award, Package } from "lucide-react";
import { Seo } from "../components/Seo";

export default function About() {
  return (
    <div data-testid="about-page" className="max-w-[1200px] mx-auto px-6 lg:px-10 py-16">
      <Seo title="About Peptide Labs N.I." description="Peptide Labs N.I. is a Northern Ireland based supplier of premium, HPLC-verified research peptides for UK laboratories and researchers." />
      <div className="max-w-3xl">
        <div className="label-mono">About</div>
        <h1 className="mt-4 text-4xl lg:text-6xl tracking-tight text-white font-medium">
          A laboratory. Not a supplement brand.
        </h1>
        <p className="mt-6 text-[#B7BCC7] leading-relaxed">
          Peptide Labs N.I. exists for one reason: to supply peptide research
          material of a quality that produces reproducible data. Every batch is
          synthesised under controlled conditions, HPLC-verified above 99% purity,
          and released with a certificate of analysis referencing the exact
          retention time and mass spectrometry confirmation of that specific lot.
        </p>
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[
          { icon: FlaskConical, k: "Synthesis", v: "Solid-phase peptide synthesis (SPPS)" },
          { icon: ShieldCheck, k: "Purification", v: "Reverse-phase HPLC ≥ 99%" },
          { icon: Award, k: "Confirmation", v: "ESI-MS / MALDI-TOF identity" },
          { icon: Package, k: "Fulfilment", v: "Cold-chain, discreet packaging" },
        ].map((p, i) => {
          const Icon = p.icon;
          return (
            <div key={i} className="p-6 border border-[#2A2A2A] rounded-2xl bg-[#0e0e0e]">
              <Icon className="text-[#1565FF]" size={20} />
              <div className="label-mono mt-6">{p.k}</div>
              <div className="mt-2 text-white text-sm tracking-tight">{p.v}</div>
            </div>
          );
        })}
      </div>

      <div className="mt-16 p-8 border border-[#2A2A2A] rounded-3xl bg-[#0e0e0e]">
        <div className="label-mono">Statement of Intended Use</div>
        <p className="mt-4 text-[#B7BCC7] leading-relaxed max-w-3xl">
          All products supplied by Peptide Labs N.I. are for in-vitro laboratory
          research purposes only. They are not manufactured, sold, or supplied for
          human or animal consumption. Purchasers assume full responsibility for
          the use of these compounds within the applicable legal and ethical
          framework of their jurisdiction.
        </p>
      </div>
    </div>
  );
}
